import { render } from "./main.vue?vue&type=template&id=4f6652cc&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=4f6652cc&scoped=true&lang=css"
import "./main.vue?vue&type=style&index=1&id=4f6652cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6652cc"]])

export default __exports__